// The fragments project-overview's items drill-down charts share — level tables on
// `defineHierarchyChart` (@rdrive/helper-chart-config; IA_ABSORPTION_PLAN Phase 5 steps 5.2–5.4):
// the joins over the row alias `i`, the items charts' source/status/filter, their terminal status
// level and the IssueTemplate short-circuit. Domain SQL, so it stays app-side (rule 2).
//
// The joins also serve useStatusHistoryCategoryChart, whose `filteredStatusHistory` rows carry the
// same `profileId` / `StatusId` columns under the same alias.

export const STATUS = 'JOIN status_templates s ON i.StatusId = s.id';
export const ITEM_TEMPLATES = 'JOIN item_templates it ON i.profileId = it.id';
export const CATEGORIES = 'JOIN categories c ON it.categoryId = c.id';
export const LOCATIONS = 'JOIN locations l ON i.locationId = l.id';
export const DRAWINGS = 'JOIN drawings d ON l.drawingId = d.id';

// The four items charts read `filteredItems` (`items` for the base's breadcrumb lookup) and filter
// by SubItemId. Scoping ('andIdIn'): every non-status filter becomes the drill scope, and a status
// click filters inside it (`AND i.SubItemId IN (<scope>)`), so it stays in the level the user
// navigated into.
export const ITEMS_CHART = {
  source: { table: (filtered) => (filtered ? 'filteredItems' : 'items'), alias: 'i' },
  status: { join: STATUS },
  filter: { table: 'items', keys: 'i.SubItemId', scope: 'andIdIn' },
};

// The terminal status level of the drawing, controller and teams/users charts: one bar per status
// title, its filter narrowed by the drill scope
export const STATUS_LEVEL = {
  level: 'status', titleKey: 'status',
  id: 's.title', title: 's.title',
  groupBy: 's.title, s.color, s.sort', partitionBy: 's.title, s.color', orderBy: 's.sort, s.title',
  filter: { joins: [STATUS], where: [['s.title', 'id']], scoped: true },
};

// The IssueTemplate short-circuit (useCategoryChart, useStatusHistoryCategoryChart): a subcategory
// bar carries its template type (`it.type`) as parentId; a profile click under an IssueTemplate
// subcategory writes 'status' to the page's v-model:currentLevel ref, skipping the subitem level.
export const issueTemplateShortCircuit = ({ drill, setLevel }) => {
  if (drill.subcategory?.parentId === 'IssueTemplate') setLevel('status');
};
